import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const swatchTray = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    activeTab: '',
    swatchTabsMetadata: {},
    lastKeyWasTab: false
  },
};

export default swatchTray;